import moment from 'moment';

/**
 * @name ConversationsController
 * @description The controller for conversations
 * @param {service} Session Unknown
 * @param {service} Events The Participants service
 * @param {angular} $stateParams Angular $stateParams service
 * @param {service} Participants The Participants service
 */
function ConversationsController(
  Session,
  Events,
  $stateParams,
  Participants
) {
  let vm = this;
  vm.$onInit = function() {
    vm.session = Session;
    vm.isReplyCollapsed = true;
  };

  updateLastReadDate();

  /**
   * @name name
   * @description description
   * @param {type} parameter Description
   */
  function updateLastReadDate() {
    let collectorId = Session.collector.id;
    let conversationId = $stateParams.conversationId;
    let appointmentId;
    Participants.get(conversationId, appointmentId, collectorId)
    .then(function(participants) {
      let formattedParticipant = {
        id: participants[0].id,
        last_read_date: moment.utc().format('YYYY-MM-DDTHH:mm:ss')
      };
      Participants.update(formattedParticipant).then(function() {
        Participants.getUnreadCount().then(function(count) {
          Events.newMessagesCount = count;
        });
      });
    });
  }
}

angular
  .module('inkfinder')
  .controller('ConversationsController', ConversationsController);



// WEBPACK FOOTER //
// ./components/messages/conversations/conversations.controller.js